var config = null;
function _resetConfig() {
  config = null;
}
function configure(options) {
  var defaults = {
    endpoint: "https://happykit.dev/api/flags",
    defaultFlags: {},
    revalidateOnFocus: true,
    clientLoadingTimeout: 3000,
    serverLoadingTimeout: 3000,
    staticLoadingTimeout: 60000
  };

  if (!options || typeof options.envKey !== "string" || options.envKey.length === 0) {
    // We can't create a custom InvalidConfigurationError as that
    // would lead to the middleware "eval" warning:
    throw new Error("@happykit/flags: Invalid configuration");
  }

  config = Object.assign({}, defaults, options);
}
function isConfigured(c) {
  return c !== null;
}

export { _resetConfig, config, configure, isConfigured };
